/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_MembersInputs */

const en_page_title_members = /** @type {(inputs: Page_Title_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const nl_page_title_members = /** @type {(inputs: Page_Title_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leden`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Page_Title_MembersInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_members = /** @type {((inputs?: Page_Title_MembersInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_MembersInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_members(inputs)
	return en_page_title_members(inputs)
});